import { useState } from "react";
import { Link } from "react-router-dom";
import { Phone, Menu, X, ChevronDown } from "lucide-react";
import { SunLogo } from "./SunLogo";
import { BUSINESS_FR, SERVICES_FR, QC_CITIES } from "../data/site-fr";

export const HeaderFr = () => {
  const [open, setOpen] = useState(false);
  const [group, setGroup] = useState(null);

  return (
    <header data-testid="site-header-fr" className="sticky top-0 z-40 bg-[#0D0E11]/90 backdrop-blur-xl border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          <Link to="/francais" data-testid="header-logo-link-fr" className="flex items-center gap-3 group">
            <SunLogo size={38} />
            <span className="font-heading leading-tight">
              <span className="block font-bold text-white text-lg group-hover:text-[#FF9100] transition-colors duration-200">1st Nations Security</span>
              <span className="block text-[10px] font-semibold uppercase tracking-widest text-[#FF9100]">Services de Sécurité</span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-7" aria-label="Navigation principale">
            <Link to="/francais" data-testid="nav-fr-accueil" className="text-sm font-medium text-gray-300 hover:text-[#FF9100] transition-colors duration-200">Accueil</Link>
            <div className="relative group">
              <button data-testid="nav-fr-services-toggle" className="flex items-center gap-1 text-sm font-medium text-gray-300 hover:text-[#FF9100] transition-colors duration-200">
                Services <ChevronDown className="w-4 h-4" />
              </button>
              <div className="invisible opacity-0 group-hover:visible group-hover:opacity-100 transition-opacity duration-200 absolute left-0 top-full pt-2 w-80">
                <div className="bg-[#14161C] border border-white/10 rounded-xl shadow-2xl p-2 max-h-[70vh] overflow-y-auto">
                  <Link to="/francais/services-de-securite" data-testid="nav-fr-services-all" className="block px-3 py-2 text-sm font-semibold text-[#FF9100] hover:bg-white/5 rounded-lg">Tous les services de sécurité</Link>
                  {SERVICES_FR.map((s) => (
                    <Link key={s.slug} to={`/francais/services-de-securite/${s.slug}`} data-testid={`nav-fr-service-${s.slug}`} className="block px-3 py-2 text-sm text-gray-300 hover:text-white hover:bg-white/5 rounded-lg">
                      {s.title}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
            <div className="relative group">
              <button data-testid="nav-fr-villes-toggle" className="flex items-center gap-1 text-sm font-medium text-gray-300 hover:text-[#FF9100] transition-colors duration-200">
                Villes <ChevronDown className="w-4 h-4" />
              </button>
              <div className="invisible opacity-0 group-hover:visible group-hover:opacity-100 transition-opacity duration-200 absolute left-0 top-full pt-2 w-72">
                <div className="bg-[#14161C] border border-white/10 rounded-xl shadow-2xl p-3 max-h-[70vh] overflow-y-auto">
                  <Link to="/francais/villes" data-testid="nav-fr-villes-all" className="block px-3 py-2 text-sm font-semibold text-[#FF9100] hover:bg-white/5 rounded-lg">Toutes les villes desservies</Link>
                  {QC_CITIES.map((c) => (
                    <Link key={c.slug} to={`/francais/villes/${c.slug}`} data-testid={`nav-fr-ville-${c.slug}`} className="block px-3 py-1.5 text-sm text-gray-300 hover:text-white hover:bg-white/5 rounded-lg">
                      {c.name}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
            <Link to="/francais/a-propos" data-testid="nav-fr-apropos" className="text-sm font-medium text-gray-300 hover:text-[#FF9100] transition-colors duration-200">À propos</Link>
            <Link to="/francais/contact" data-testid="nav-fr-contact" className="text-sm font-medium text-gray-300 hover:text-[#FF9100] transition-colors duration-200">Contact</Link>
            <Link to="/" data-testid="nav-fr-en" className="text-xs font-bold text-[#FF9100] border border-[#FF9100]/40 rounded-full px-3 py-1.5 hover:bg-[#FF9100]/10 transition-colors">EN</Link>
          </nav>

          <div className="flex items-center gap-3">
            <a href={BUSINESS_FR.phoneHref} data-testid="header-call-btn-fr" className="hidden md:inline-flex items-center gap-2 bg-[#FF9100] hover:bg-[#FF5500] text-[#0D0E11] font-semibold text-sm px-4 py-2 rounded-full transition-colors duration-200">
              <Phone className="w-4 h-4" /> {BUSINESS_FR.phone}
            </a>
            <button data-testid="mobile-menu-toggle-fr" onClick={() => setOpen(!open)} aria-label="Ouvrir le menu" className="lg:hidden text-gray-200 hover:text-[#FF9100] transition-colors">
              {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu-fr" className="lg:hidden border-t border-white/10 bg-[#0D0E11] max-h-[75vh] overflow-y-auto">
          <div className="px-4 py-4 space-y-1">
            <Link to="/francais" onClick={() => setOpen(false)} data-testid="mobile-nav-fr-accueil" className="block py-2 text-gray-200 font-medium">Accueil</Link>
            <button data-testid="mobile-fr-services-toggle" onClick={() => setGroup(group === "services" ? null : "services")} className="flex w-full items-center justify-between py-2 text-gray-200 font-medium">
              Services <ChevronDown className={`w-4 h-4 transition-transform ${group === "services" ? "rotate-180" : ""}`} />
            </button>
            {group === "services" && (
              <div className="pl-4 space-y-1">
                <Link to="/francais/services-de-securite" onClick={() => setOpen(false)} data-testid="mobile-fr-services-all" className="block py-1.5 text-[#FF9100] text-sm font-semibold">Tous les services</Link>
                {SERVICES_FR.map((s) => (
                  <Link key={s.slug} to={`/francais/services-de-securite/${s.slug}`} onClick={() => setOpen(false)} data-testid={`mobile-fr-service-${s.slug}`} className="block py-1.5 text-sm text-gray-400">{s.title}</Link>
                ))}
              </div>
            )}
            <button data-testid="mobile-fr-villes-toggle" onClick={() => setGroup(group === "villes" ? null : "villes")} className="flex w-full items-center justify-between py-2 text-gray-200 font-medium">
              Villes <ChevronDown className={`w-4 h-4 transition-transform ${group === "villes" ? "rotate-180" : ""}`} />
            </button>
            {group === "villes" && (
              <div className="pl-4 space-y-1">
                <Link to="/francais/villes" onClick={() => setOpen(false)} data-testid="mobile-fr-villes-all" className="block py-1.5 text-[#FF9100] text-sm font-semibold">Toutes les villes</Link>
                {QC_CITIES.map((c) => (
                  <Link key={c.slug} to={`/francais/villes/${c.slug}`} onClick={() => setOpen(false)} data-testid={`mobile-fr-ville-${c.slug}`} className="block py-1.5 text-sm text-gray-400">{c.name}</Link>
                ))}
              </div>
            )}
            <Link to="/francais/a-propos" onClick={() => setOpen(false)} data-testid="mobile-nav-fr-apropos" className="block py-2 text-gray-200 font-medium">À propos</Link>
            <Link to="/francais/contact" onClick={() => setOpen(false)} data-testid="mobile-nav-fr-contact" className="block py-2 text-gray-200 font-medium">Contact</Link>
            <Link to="/" onClick={() => setOpen(false)} data-testid="mobile-nav-fr-en" className="block py-2 text-[#FF9100] font-bold">English</Link>
            <a href={BUSINESS_FR.phoneHref} data-testid="mobile-call-btn-fr" className="mt-2 flex items-center justify-center gap-2 bg-[#FF9100] text-[#0D0E11] font-semibold px-4 py-3 rounded-full">
              <Phone className="w-4 h-4" /> {BUSINESS_FR.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
